import React from "react";
import { Empty } from "antd";
import { _t } from "./InjectIntlContext";

export function NoData() {
  return <Empty description={_t("no_data")} />;
}
